<script setup lang='ts'>
import {computed, toValue, onMounted} from 'vue';
import type {DeepReadonly} from 'vue';
import useCheckout from '../composables/useCheckout';
import type {WoocommerceShippingRate} from '@/types/woocommerce.types';
import {i18n} from "@/libs/wordpress.facade";

const {step, wooCart} = useCheckout();

const shippingModes = computed(() => {
	const cart = toValue(wooCart.cart);
	const result: any = {shipping_rate: undefined, italdeposito_rate: undefined};
	if(!cart || !cart.shipping_rates || cart.shipping_rates.length == 0) return result;
	result.shipping_rate = [...cart.shipping_rates[0].shipping_rates].filter(rate => !['italdeposito_shipping'].includes(rate.method_id)).sort((r1, r2) => r1.selected ? -1 : 1).find(rate => rate);
	result.italdeposito_rate = cart.shipping_rates[0].shipping_rates.find(rate => ['italdeposito_shipping'].includes(rate.method_id));
	
	return result
});

function selectShippingRate(shippingRate: DeepReadonly<WoocommerceShippingRate>){
	wooCart.selectShippingRate({
		package_id: 0,
		rate_id: shippingRate.rate_id
	});
}

function confirm(){
	step.value++;
}

const cartUrl = window.itlp_checkout_params?.cart_url;

</script>
<template lang='pug'>
fieldset.itlp-checkout-shipping-mode-selection-content
	legend.screen-reader-text {{i18n.__('Come vuoi gestire i tuoi prodotti?', 'italpreziosi')}}
	button.itlp-checkout-shipping-mode-card(
		v-if='shippingModes.shipping_rate' 
		:class="{'itlp-checkout-shipping-mode-card-selected': shippingModes.shipping_rate.selected}" 
		@click='selectShippingRate(shippingModes.shipping_rate)'
		:aria-label="i18n.__('Ricevi i prodotti', 'italpreziosi')"
		:aria-pressed="shippingModes.shipping_rate.selected? 'true' : 'false'"
	)
		.itlp-checkout-shipping-mode-card-header
			.itlp-checkout-shipping-mode-card-fake-radio
			.itlp-checkout-shipping-mode-card-header-title {{i18n.__('Ricevi i prodotti', 'italpreziosi')}}
			img.itlp-checkout-shipping-mode-card-icon(decoding="async" src="https://shop.italpreziosi.it/wp-content/uploads/2025/04/icona-spedizione-portavalori.svg" alt="Spedizione assicurata con corriere portavalori")
		.itlp-checkout-shipping-mode-card-description
			span {{i18n.__('Italpreziosi ti offre le seguenti modalità per ricevere o ritirare i tuoi prodotti. Selezionando \'Ricevi il prodotto\' potrai scegliere l\'opzione che preferisci in fase di checkout.', 'italpreziosi')}}
			.itlp-checkout-shipping-mode-check {{i18n.__('Ritiro presso Italpreziosi', 'italpreziosi')}}
			.itlp-checkout-shipping-mode-check {{i18n.__('Spedizione con furgone portavalori', 'italpreziosi')}}
	button.itlp-checkout-shipping-mode-card(
		v-if='shippingModes.italdeposito_rate' 
		:class="{'itlp-checkout-shipping-mode-card-selected': shippingModes.italdeposito_rate.selected}" 
		@click='selectShippingRate(shippingModes.italdeposito_rate)' 
		:aria-label="i18n.__('Italdeposito', 'italpreziosi')"
		:aria-pressed="shippingModes.italdeposito_rate.selected? 'true' : 'false'"
	)
		.itlp-checkout-shipping-mode-card-header
			.itlp-checkout-shipping-mode-card-fake-radio
			.itlp-checkout-shipping-mode-card-header-title {{i18n.__('Italdeposito', 'italpreziosi')}}
		.itlp-checkout-shipping-mode-card-description
			span {{i18n.__('Italdeposito ti permette di lasciare i tuoi acquisti direttamete nel nostro deposito assicurato.', 'italpreziosi')}}
			.itlp-checkout-shipping-mode-check {{i18n.__('QR code di tracciabilità', 'italpreziosi')}}
			.itlp-checkout-shipping-mode-check {{i18n.__('Prodotti sempre assicurati', 'italpreziosi')}}
			.itlp-checkout-shipping-mode-check {{i18n.__('Investimenti in totale sicurezza', 'italpreziosi')}}
			.itlp-checkout-shipping-mode-check {{i18n.__('Acquistare prodotti senza doverli ricevere fisicamente', 'italpreziosi')}}
.itlp-checkout-shipping-mode-footer
	a.button(:href='cartUrl') {{i18n.__('Torna al carrello', 'italpreziosi')}}
	button(@click='confirm()') {{i18n.__('Conferma', 'italpreziosi')}}
</template>